import Loadable from "react-loadable";
import { Loader } from "../Components/ui/Loader";

export default (location) => Loadable({
    loader: () => import("../Components/"+location),
    loading: Loader
})